<script>
import { HorizontalBar } from "vue-chartjs";

export default {
  extends: HorizontalBar,
  props: {
    chartdata: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: "",
    }
  },
  mounted() {
    this.renderChart(this.chartdata, {
      // responsive: true,
      title: {
        display: true,
        text: this.title,
      },
      layout: {
        padding: {
          bottom: 25, //set that fits the best
          left: 100,
        },
      },
      // maintainAspectRatio: false,
      legend: {
        display: true,
        position: "bottom",
        fullSize: false,
      },
      tooltips: {
        xAlign: "center",
        position: "nearest",
      },
      scales: {
        xAxes: [
          {
            stacked: true,
          },
        ],
        yAxes: [
          {
            stacked: true,
          },
        ],
      },
    });
  },
  watch: {
    chartdata() {
      this.$data._chart.update();
    },
  },
};
</script>
